import {parseShapeFile} from "../../utils/shapeFileUtils";
import {Alert, Button, Tooltip} from "@mui/material";
import React, {useState} from "react";
import {Field} from "../../types/domain/field";
import {useTranslation} from "react-i18next";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";

interface Props {
    setFields: (fields: Field[]) => void;
}

export const FieldsShapeFileUploadForm: React.FC<Props> = ({setFields}) => {
    const {t} = useTranslation();
    const [error, setError] = useState<string | null>(null);
    const handleCloseAlert = () => {
        setError(null);
    };

    const handleFileUpload = async (event: React.ChangeEvent) => {
        const target = event.target as HTMLInputElement & {files: FileList};
        const file = target.files[0];
        if (file) {
            const [fields, _error] = await parseShapeFile(file);
            setFields(fields);
            setError(_error);
        }
    };

    return (
        <>
            {error && (
                <Alert severity="error" onClose={handleCloseAlert}>
                    {error}
                </Alert>
            )}
            <div>
                <input
                    style={{display: "none"}}
                    id="file-upload"
                    type="file"
                    accept=".kml,.shp,.zip"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        void handleFileUpload(e);
                        //resetting the target, that allows to upload same file
                        e.target.value = "";
                    }}
                />
                <Tooltip title={t("fields.fields_shape_upload_form.tooltip")}>
                    <label htmlFor="file-upload">
                        <Button
                            component="span"
                            variant={"outlined"}
                            color={"secondary"}
                            startIcon={<DriveFolderUploadIcon />}
                            style={{
                                justifyContent: "flex-start",
                                width: "100%",
                                borderRadius: "0px",
                                backgroundColor: "#DBDEE6",
                                color: "#2B303F",
                                borderWidth: "0px",
                                boxShadow: "none",
                                textTransform: "uppercase",
                                fontWeight: 500,
                                fontSize: 12,
                                padding: "9px 9px",
                                lineHeight: "normal",
                                minWidth: "132px",
                            }}
                        >
                            {t("fields.fields_shape_upload_form.upload_button")}
                        </Button>
                    </label>
                </Tooltip>
            </div>
        </>
    );
};
